export const STORAGE_KEYS = {
  billingHash: "tm-membership-billingHash",
  billingCounter: "tm-membership-billingCounter",
};
